export default "__VITE_ASSET__Br_kVkgH__"